module.exports = __webpack_public_path__ + "static/media/rob.b34fc52c.png";